if(typeof window !== 'undefined' && window){
    (function(w, d) { w.CollectId = "5ea7c08082d74543a6558281"; var h = d.head || d.getElementsByTagName("head")[0]; var s = d.createElement("script"); s.setAttribute("type", "text/javascript"); s.setAttribute("src", "https://collectcdn.com/launcher.js"); h.appendChild(s); })(window, document);
}


// WEBPACK FOOTER //
// ./src/layouts/chatLoader.js